import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'
import moment from 'moment'
import environment from '../../../environment'
import { message, Modal, Tabs, Select, Skeleton } from 'antd'
import Lottie from 'react-lottie'

import { Text } from '../../Reusable/Text'
import { Image } from '../../Reusable/Image'
import { LabeledInput } from '../../Reusable/Input'
import { Flex, FlexColumn, CardContainer } from '../../Reusable/Container'
import { Button, TextButton, ImageButton } from '../../Reusable/Button'
import { ErrorAlert } from '../../Reusable/Alert'
import { FromAccountOption } from '../../Reusable/Option'
import { getBPAccountsWithAccess, getFeaturePerm, toCurrency, toNumberStr } from '../../../Utils/util'
import { addDataToStore, SAVE_DATA, BNK_SAVE_DATA } from '../../../Actions/actions'
import { apiPOSTReq } from '../../../Utils/api'
import ModalClose from '../../../Images/modal-close.png'
import AionIcon from '../../../Images/aion-bank-icon.png'
import CircleLoader from '../../Reusable/CircleLoader'
import HYASuccess from '../../../Images/hya-success.svg'
import CheckLoadingAnimation from '../../Lotties/check-loading.json'

const { Option } = Select

const HighYieldAccountCard = (props) => {
    const [dropdownVisible, setDropdownVisible] = useState(false)
    const [selected, setSelected] = useState(false)
    const [loading, setLoading] = useState(false)
    const [hyaData, setHYAData] = useState()
    const [addFunds, setAddFunds] = useState(false)
    const [withdrawFunds, setWithdrawFunds] = useState(false)
    const [fromAccount, setFromAccount] = useState()
    const [toAccount, setToAccount] = useState()
    const [transferAmount, setTransferAmount] = useState()
    const [errorField, setErrorField] = useState()
    const [errorMessage, setErrorMessage] = useState()
    const [submitLoading, setSubmitLoading] = useState(false)
    const [showAddFundsResult, setShowAddFundsResult] = useState(false)
    const [showWithdrawFundsResult, setShowWithdrawFundsResult] = useState(false)
    const [isComplete, setIsComplete] = useState(false);

    const { account, getAccounts, accountInterestInfo } = props

    useEffect(() => {
        var Accounts = getBPAccountsWithAccess("Payments", { permType: "manage", getActiveAccounts: true }) || []
        Accounts = Accounts.filter(acc => acc.accountId !== account?.accountId)
        if (Accounts?.length === 1) {
            setFromAccount(Accounts[0])
            setToAccount(Accounts[0])
        }

        if (props.store.hyaData) setHYAData(props.store.hyaData)
        else getInterestRateInfo()
    }, [])

    useEffect(() => {
        var urlStr = props.location.search.replace('?', '');
        var action = (new URLSearchParams(urlStr).get('action') || '');
        if (action == "move_money") {
            setSelected(true)
        }
    }, [props.location.search])

    useEffect(() => {
        setErrorField(null)
        setErrorMessage(null)
    }, [fromAccount, addFunds, withdrawFunds])


    const getInterestRateInfo = () => {
        var body = {
            "FromDate": moment().format('YYYY-MM-DD'),
            "InterestRateType": "InterestPayout",
            "AccountNumber": "XXXX",
            "AccountType": "CHECKINGYIELD",
        }

        setLoading(true)
        console.log("HYA getInterestRateInfo", body)
        apiPOSTReq(`${environment.bbBaseUrl}/bb/getInterestRateInfo`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                const data = resp
                if (data.result) {
                    console.log("HYA getInterestRateInfo", resp)

                    const hyaData = {
                        hyaAPY: data.rateAPY,
                        fdicLink: data.fdicLink,
                        fdicAPY: data.fdicAPY,
                        fdicRate: data.fdicRate,
                        fdicEffectiveDate: data.fdicEffectiveDate,
                    }

                    setHYAData(hyaData)
                    props.dispatch(addDataToStore(SAVE_DATA, { hyaData }))
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR HYA getInterestRateInfo", error, err, resp)
                ErrorAlert({ description: error.message })
            } finally {
                setLoading(false)
            }
        })
    }

    const handleSelectFromAccount = (value, option) => {
        var Accounts = getBPAccountsWithAccess("Payments", { permType: "manage", getActiveAccounts: true })
        var account = Accounts.find(a => a.accountId === value)
        setFromAccount(account)
    }

    const handleSelectToAccount = (value, option) => {
        var Accounts = getBPAccountsWithAccess("Payments", { permType: "manage", getActiveAccounts: true })
        var account = Accounts.find(a => a.accountId === value)
        setToAccount(account)
    }

    const getAccountOptions = (id) => {
        var Accounts = getBPAccountsWithAccess("Payments", { permType: "manage", getActiveAccounts: true }) || []
        if (id === "fromAccount") Accounts = Accounts.filter(acc => acc.accountType !== "ACCOUNTS_RECEIVABLE")

        var options = []
        Accounts.forEach(acc => {
            if (acc?.accountId !== account?.accountId) options.push(
                <Option key={acc.accountId} id={id} value={acc.accountId} style={{ backgroundColor: "transparent" }}>
                    <FromAccountOption account={acc} />
                </Option>
            )
        })
        return options
    }

    const addFundsTransfer = () => {
        if (!transferAmount) {
            setErrorField("transferAmount")
            setErrorMessage("Amount is required")
            return
        }

        const transferMax = fromAccount && Math.max(0, fromAccount.availableBalance);

        if (transferAmount > transferMax) {
            setErrorField("transferAmount")
            setErrorMessage("The transfer amount exceeds the available balance in your account")
            return
        }

        if (!fromAccount) {
            setErrorField("fromAccount")
            return
        }

        setErrorField(null)
        setErrorMessage(null)

        var body = {
            "fromAccountId": fromAccount.accountId || "",
            "toAccountId": account.accountId || "",
            "FromAccountNumber": fromAccount.accountNumber,
            "ToAccountNumber": account.accountNumber,
            "amount": toNumberStr(transferAmount),
            "amountStr": toNumberStr(transferAmount),
            "operationType": "user",
            "userNote": "High Yield Deposit",
            "purpose": "High Yield Deposit",
            "remittanceInfo": "High Yield Deposit"
        }

        setSubmitLoading(true)
        setAddFunds(false)
        setShowAddFundsResult(true)
        console.log("HYA confirmPayment body", body)
        apiPOSTReq(`${environment.bbBaseUrl}/bb/xfer`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                const data = resp
                if (data.result) {
                    console.log("HYA confirmPayment resp", resp)
                    setIsComplete(true)
                    setFromAccount(null)
                    setToAccount(null)
                    getAccounts()
                    setTimeout(() => {
                        setShowAddFundsResult(false);
                        setTransferAmount(null)
                        setIsComplete(false)
                    }, 2000);
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR HYA confirmPayment", error, err, resp)
                ErrorAlert({ description: error.message })
                setShowAddFundsResult(false);
                setTransferAmount(null)
                setIsComplete(false)
            } finally {
                setSubmitLoading(false)
            }
        })
    }

    const withdrawFundsTransfer = () => {
        if (!transferAmount) {
            setErrorField("transferAmount")
            setErrorMessage("Amount is required")
            return
        }

        const transferMax = account && Math.max(0, account.availableBalance);

        if (transferAmount > transferMax) {
            setErrorField("transferAmount")
            setErrorMessage("The transfer amount exceeds the available balance in your account")
            return
        }

        if (!toAccount) {
            setErrorField("toAccount")
            setErrorMessage("")
            return
        }

        setErrorField(null)
        setErrorMessage(null)

        var body = {
            "fromAccountId": account.accountId || "",
            "toAccountId": toAccount.accountId || "",
            "FromAccountNumber": account.accountNumber,
            "ToAccountNumber": toAccount.accountNumber,
            "amount": toNumberStr(transferAmount),
            "amountStr": toNumberStr(transferAmount),
            "operationType": "user",
            "userNote": "High Yield Withdrawal",
            "purpose": "High Yield Withdrawal",
            "remittanceInfo": "High Yield Withdrawal"
        }

        setSubmitLoading(true)
        setWithdrawFunds(false)
        setShowWithdrawFundsResult(true)
        console.log("HYA confirmPayment body", body)
        apiPOSTReq(`${environment.bbBaseUrl}/bb/xfer`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                const data = resp
                if (data.result) {
                    console.log("HYA confirmPayment resp", resp)
                    setIsComplete(true)
                    setFromAccount(null)
                    setToAccount(null)
                    getAccounts()
                    setTimeout(() => {
                        setShowWithdrawFundsResult(false);
                        setTransferAmount(null)
                        setIsComplete(false)
                    }, 2000);
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR HYA confirmPayment", error, err, resp)
                ErrorAlert({ description: error.message })
                setShowWithdrawFundsResult(false);
                setTransferAmount(null)
                setIsComplete(false)
            } finally {
                setSubmitLoading(false)
            }
        })
    }

    var fromAccountOptions = getAccountOptions("fromAccount")
    var toAccountOptions = getAccountOptions("toAccount")

    const nickNameMaxLen = 18
    var fromAccountNickName = `${(fromAccount?.nickName || "").trim().substr(0, nickNameMaxLen)}${(fromAccount?.nickName || "").trim().length > nickNameMaxLen ? "..." : ""}`
    var toAccountNickName = `${(toAccount?.nickName || "").trim().substr(0, nickNameMaxLen)}${(toAccount?.nickName || "").trim().length > nickNameMaxLen ? "..." : ""}`

    return (

        <CardContainer
            padding='0'
            height={'324px'}
            style={{ marginLeft: 0, minWidth: 450, width: 450 }}
        >
            <FlexColumn between left style={{ padding: 24 }} fullWidth fullHeight>
                {
                    (!addFunds && !withdrawFunds && !showAddFundsResult && !showWithdrawFundsResult) &&
                    <>
                        <FlexColumn start fullWidth fullHeight>
                            <Text heading margin="0 0 24px">High Yield Account</Text>

                            <LabeledInput
                                nomargin
                                type='read-only'
                                label='Available balance'
                                value={<Text size="24px" margin="4px 0 0">${toCurrency(account.availableBalance)}</Text>}
                            />

                            <Flex fullWidth between style={{ marginTop: 24 }}>
                                <LabeledInput
                                    nomargin
                                    type='read-only'
                                    label='APY'
                                    value={<Text>{hyaData?.hyaAPY}%</Text>}
                                    tooltip={"Annual Percentage Yield (APY) is a rate that reflects the total amount of interest to be paid on an account, based on the interest rate and frequency of compounding for a 365-day period (366-day calendar year in a leap year)."}
                                />

                                <LabeledInput
                                    nomargin
                                    type='read-only'
                                    label='Interest accrued this month'
                                    value={<Text>{accountInterestInfo?.currentMonthInterestAmount ? `$${toCurrency(accountInterestInfo?.currentMonthInterestAmount)}` : accountInterestInfo?.currentMonthInterestAmount === 0 ? `$${toCurrency(0)}` : '--'}</Text>}
                                />
                            </Flex>
                        </FlexColumn>

                        <Flex start centerH gap="24px">
                            <Button solid text="Add funds" onClick={() => setAddFunds(true)} />
                            <TextButton disabled={account?.currentBalance === 0} weight='400' underline text="Withdraw funds" onClick={() => setWithdrawFunds(true)} />
                        </Flex>
                    </>
                }

                {
                    addFunds &&
                    <>
                        <FlexColumn start fullWidth fullHeight>
                            <Flex fullWidth between>
                                <Text heading margin="0 0 0">Add funds</Text>

                                <ImageButton src={ModalClose} onClick={() => setAddFunds(false)} />
                            </Flex>

                            <FlexColumn start gap="18px" style={{ marginTop: 8 }}>
                                <LabeledInput
                                    type="number"
                                    label="Transfer amount"
                                    id="transferAmount"
                                    key="transferAmount"
                                    nomargin
                                    className="no-left-padding"
                                    placeholder="Enter transfer amount"
                                    min={0}
                                    formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    value={transferAmount}
                                    onChange={(value) => setTransferAmount(value)}
                                    error={errorField === "transferAmount"}
                                    errorMessage={errorMessage}
                                />

                                <LabeledInput
                                    label="From account"
                                    type="select"
                                    id="fromAccount"
                                    nomargin
                                    key="fromAccount"
                                    placeholder="Select account"
                                    value={fromAccount && <Flex between centerHorizontally style={{ height: 30 }}>
                                        <Text><img width='16px' height='16px' src={AionIcon} style={{ marginRight: 8, marginBottom: 2 }} />{`${fromAccountNickName} • ${fromAccount.mask}`}</Text>
                                        <Text size='14px' lightText style={{ marginLeft: 8 }}>${toCurrency(fromAccount.availableBalance)}</Text>
                                    </Flex>}
                                    autoFocus
                                    onChange={handleSelectFromAccount}
                                    error={errorField === "fromAccount"}
                                    errorMessage="From account is required"
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    className='parent-node-select-dropdown-menu'
                                >
                                    {fromAccountOptions}
                                </LabeledInput>
                            </FlexColumn>
                        </FlexColumn>

                        <Button solid text="Confirm" onClick={() => addFundsTransfer()} loading={submitLoading} />
                    </>
                }

                {
                    withdrawFunds &&
                    <>
                        <FlexColumn start fullWidth fullHeight>
                            <Flex fullWidth between>
                                <Text heading margin="0 0 0">Withdraw funds</Text>

                                <ImageButton src={ModalClose} onClick={() => setWithdrawFunds(false)} />
                            </Flex>

                            <FlexColumn start gap="18px" style={{ marginTop: 8 }}>
                                <LabeledInput
                                    type="number"
                                    label="Transfer amount"
                                    id="transferAmount"
                                    key="transferAmount"
                                    nomargin
                                    className="no-left-padding"
                                    placeholder="Enter transfer amount"
                                    min={0}
                                    formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    value={transferAmount}
                                    onChange={(value) => setTransferAmount(value)}
                                    error={errorField === "transferAmount"}
                                    errorMessage={errorMessage}
                                />

                                <LabeledInput
                                    label="To account"
                                    type="select"
                                    id="toAccount"
                                    nomargin
                                    key="toAccount"
                                    placeholder="Select account"
                                    value={toAccount && <Flex between centerHorizontally style={{ height: 30 }}>
                                        <Text><img width='16px' height='16px' src={AionIcon} style={{ marginRight: 8, marginBottom: 2 }} />{`${toAccountNickName} • ${toAccount.mask}`}</Text>
                                        <Text size='14px' lightText style={{ marginLeft: 8 }}>${toCurrency(toAccount.availableBalance)}</Text>
                                    </Flex>}
                                    autoFocus
                                    onChange={handleSelectToAccount}
                                    error={errorField === "toAccount"}
                                    errorMessage="To account is required"
                                >
                                    {toAccountOptions}
                                </LabeledInput>
                            </FlexColumn>
                        </FlexColumn>

                        <Button solid text="Confirm" onClick={() => withdrawFundsTransfer()} loading={submitLoading} />
                    </>
                }

                {
                    showAddFundsResult &&
                    <FlexColumn center fullWidth fullHeight>
                        <CircleLoader isComplete={isComplete} />

                        {
                            isComplete ?
                                <Text heading margin="8px 0 0">${toCurrency(transferAmount)} deposited</Text>
                                :
                                <Text heading margin="8px 0 0">Transferring funds...</Text>
                        }
                    </FlexColumn>
                }

                {
                    showWithdrawFundsResult &&
                    <FlexColumn center fullWidth fullHeight>
                        <CircleLoader isComplete={isComplete} />

                        {
                            isComplete ?
                                <Text heading margin="8px 0 0">${toCurrency(transferAmount)} withdrawn</Text>
                                :
                                <Text heading margin="8px 0 0">Withdrawing funds...</Text>
                        }
                    </FlexColumn>
                }
            </FlexColumn>
        </CardContainer>
    )
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer,
        bankingStore: state.bankingAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(HighYieldAccountCard)))